import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';

import {
  getTfrTemplates as getTfrTemplatesApi,
  createTfrTemplate as createTfrTemplateApi,
  updateTfrTemplate as updateTfrTemplateApi,
  deleteTfrTemplate as deleteTfrTemplateApi,
} from '../../services';
import { displayNotification, checkOnline, getNotification } from '../notifications';
import {
  REQUEST_TFR_TEMPLATE,
  ADD_TFR_TEMPLATE,
  UPDATE_TFR_TEMPLATE,
  DELETE_TFR_TEMPLATE,
  requestTfrTemplates,
  receiveTfrTemplates,
  removeTfrTemplate,
} from './actions';

export function* doRequestTfrTemplates(action) {
  const { query } = action;
  try {
    const response = yield call(getTfrTemplatesApi, query);
    yield put(receiveTfrTemplates(response.values));
  } catch (e) {
    console.error('Unable to get TFR templates: ', e);
    yield call(checkOnline);
    yield put(displayNotification(getNotification('requestTfrTemplates', 'error')()));
  }
}

export function* doCreateTfrTemplate(action) {
  const { payload, callback } = action;
  try {
    yield call(createTfrTemplateApi, payload);
    yield put(requestTfrTemplates({ site: payload.site, templateType: payload.templateType }));
    yield put(displayNotification(getNotification('addTfrTemplates', 'success')()));
  } catch (e) {
    console.error('Unable to add TFR template: ', e);
    yield call(checkOnline);
    yield put(displayNotification(getNotification('addTfrTemplates', 'error')()));
  }
  yield callback();
}

export function* doUpdateTfrTemplate(action) {
  const { templateId, payload, callback } = action;
  try {
    yield call(updateTfrTemplateApi, templateId, payload);
    yield put(requestTfrTemplates({ site: payload.site, templateType: payload.templateType }));
    yield put(displayNotification(getNotification('updateTfrTemplates', 'success')()));
  } catch (e) {
    console.error('Unable to update TFR templates: ', e);
    yield call(checkOnline);
    yield put(displayNotification(getNotification('updateTfrTemplates', 'error')()));
  }
  yield callback();
}

export function* doDeleteTfrTemplate(action) {
  const { templateId, callback } = action;
  try {
    yield call(deleteTfrTemplateApi, templateId);
    yield put(removeTfrTemplate(templateId));
    yield put(displayNotification(getNotification('deleteTfrTemplate', 'success')()));
  } catch (e) {
    console.error('Unable to delete TFR Template: ', e);
    yield call(checkOnline);
    yield put(displayNotification(getNotification('deleteTfrTemplate', 'error')()));
  }
  yield callback();
}

export const sagas = [
  takeLatest(REQUEST_TFR_TEMPLATE, doRequestTfrTemplates),
  takeEvery(ADD_TFR_TEMPLATE, doCreateTfrTemplate),
  takeLatest(UPDATE_TFR_TEMPLATE, doUpdateTfrTemplate),
  takeLatest(DELETE_TFR_TEMPLATE, doDeleteTfrTemplate),
];
